'use strict';
/* eslint hubspot-dev/hubspot-is-special: 0 */
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.detectAuth = exports._didDetectAuth = exports._didDetectUnauthed = exports.authenticateUser = exports.changePrimaryHub = undefined;

var _q = require('q');

var _q2 = _interopRequireDefault(_q);

var _AuthenticationActionTypes = require('../actionTypes/AuthenticationActionTypes');

var _HublessAuth = require('../auth/HublessAuth');

var _HublessAuth2 = _interopRequireDefault(_HublessAuth);

var _LoginDAO = require('../data/LoginDAO');

var _PortalIdContainer = require('../globals/PortalIdContainer');

var _PortalIdContainer2 = _interopRequireDefault(_PortalIdContainer);

var _QueryParamsContainer = require('../globals/QueryParamsContainer');

var _QueryParamsContainer2 = _interopRequireDefault(_QueryParamsContainer);

var _Logger = require('../lib/Logger');

var _Logger2 = _interopRequireDefault(_Logger);

var _Auth = require('../selectors/Auth');

var _OAuth = require('../selectors/OAuth');

var _actionWithPayload = require('../utils/actionWithPayload');

var _actionWithPayload2 = _interopRequireDefault(_actionWithPayload);

var _Auth2 = require('../utils/Auth');

var _Auth3 = _interopRequireDefault(_Auth2);

var _isFunnel = require('../utils/isFunnel');

var _isFunnel2 = _interopRequireDefault(_isFunnel);

var _AnalyticsActions = require('./AnalyticsActions');

var _UserInfoActions = require('./UserInfoActions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOG = _Logger2.default.getLogger('AuthenticationActions');

function attemptUserLogin(email, password) {
  return (0, _LoginDAO.loginUser)({
    email: email,
    password: password
  }).catch(function (resp) {
    var responseText = resp.responseText,
        status = resp.status,
        responseJSON = resp.responseJSON;


    LOG.error('attemptUserLogin-cookie: ' + (status || 'no-status'), {
      extra: {
        email: email,
        status: status,
        responseText: responseText,
        responseMessage: responseJSON && responseJSON.message ? responseJSON.message : '',
        fullResponse: resp
      }
    });

    return false;
  });
}

function attemptUserLoginThroughGoogle(idToken) {
  return (0, _LoginDAO.loginUserThroughGoogle)({ idToken: idToken }).catch(function (resp) {
    var responseText = resp.responseText,
        status = resp.status,
        responseJSON = resp.responseJSON;

    LOG.error('attemptUserLogin-google: ' + (status || 'no-status'), {
      extra: {
        status: status,
        responseText: responseText,
        responseMessage: responseJSON && responseJSON.message ? responseJSON.message : '',
        fullResponse: resp
      }
    });

    return false;
  });
}

function attemptAuthentication(portalId) {
  var authRefresh = void 0;

  if (_Auth3.default.get().portalId) {
    // Existing users need to use the auth token that corresponds
    // to their new portal, not the one they logged into earlier.
    authRefresh = _Auth3.default.refreshAuth(portalId);
  } else {
    // 🚨 TODO: better interface 🚨 split up login and user info fetching
    if (_isFunnel2.default.growthHub()) {
      authRefresh = _HublessAuth2.default.init();
    } else {
      authRefresh = _Auth3.default.init();
    }
  }

  return authRefresh;
}

var changePrimaryHub = exports.changePrimaryHub = function changePrimaryHub() {
  var portalId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  _PortalIdContainer2.default.set(portalId);
  return attemptAuthentication(portalId);
};

var authenticateUser = exports.authenticateUser = function authenticateUser() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$email = _ref.email,
      email = _ref$email === undefined ? '' : _ref$email,
      _ref$password = _ref.password,
      password = _ref$password === undefined ? '' : _ref$password,
      _ref$portalId = _ref.portalId,
      portalId = _ref$portalId === undefined ? '' : _ref$portalId,
      _ref$canLogin = _ref.canLogin,
      canLogin = _ref$canLogin === undefined ? true : _ref$canLogin;

  return function (dispatch, getState) {
    if (portalId && !_PortalIdContainer2.default.get()) {
      _PortalIdContainer2.default.set(portalId);
    }

    var state = getState();
    var googleOAuthVerifyRequestState = (0, _OAuth.getGoogleOAuthVerifyRequestState)(state);
    var maybeIdToken = (0, _OAuth.getIdToken)(state);

    var loginPromise = void 0;
    if (canLogin && email && password) {
      loginPromise = attemptUserLogin(email, password);
    } else if (googleOAuthVerifyRequestState.isSuccessful() && Boolean(maybeIdToken)) {
      loginPromise = attemptUserLoginThroughGoogle(maybeIdToken);
    } else {
      loginPromise = _q2.default.Promise.resolve();
      //password will only show if the value is there, not the actual value
      if (!(0, _Auth.didDetectAuth)(state)) {
        //this doesn't seem to be happening anymore
        LOG.warn('Reaching empty promise authenticating user');
      }
    }

    return loginPromise.then(function () {
      return attemptAuthentication(portalId).catch(function (e) {
        LOG.error('attemptAuthentication-failed', {
          extra: {
            e: e
          }
        });
        return _q2.default.Promise.reject();
      });
    }).then(function () {
      dispatch((0, _actionWithPayload2.default)(_AuthenticationActionTypes.AUTHENTICATION_SUCCEEDED));
    }).catch(function () {
      dispatch((0, _actionWithPayload2.default)(_AuthenticationActionTypes.AUTHENTICATION_FAILED));
    });
  };
};

var logAuthState = function logAuthState(isAuthed) {
  return function () {
    (0, _AnalyticsActions.trackEvent)('authState', {
      action: 'auth state',
      eventSubtype: isAuthed ? 'authed' : 'not-authed'
    });
  };
};

var _didDetectUnauthed = exports._didDetectUnauthed = function _didDetectUnauthed() {
  return (0, _actionWithPayload2.default)(_AuthenticationActionTypes.DETECT_AUTH_UNAUTHED);
};

var didDetectUnauthed = function didDetectUnauthed(handler) {
  return function (dispatch) {
    dispatch(logAuthState(false));
    (0, _AnalyticsActions.trackEvent)('redirect', {
      action: 'redirect unauthenticated',
      screen: 'detect-auth',
      userInitiated: false
    });

    dispatch(_didDetectUnauthed());

    if (handler) {
      dispatch(handler());
    }
  };
};

// TODO: remove after https://git.hubteam.com/HubSpot/signup-ui/issues/1465
var _didDetectAuth = exports._didDetectAuth = function _didDetectAuth() {
  return (0, _actionWithPayload2.default)(_AuthenticationActionTypes.DETECT_AUTH_AUTHED);
};

var didDetectAuth = function didDetectAuth(handler, AuthHandler) {
  return function (dispatch) {
    dispatch(logAuthState(true));

    // TODO: call action to store above data in auth store
    var userData = AuthHandler.get().user;
    dispatch((0, _UserInfoActions.updateUser)({
      firstName: userData.get('first_name'),
      lastName: userData.get('last_name'),
      email: userData.get('email')
    }));

    dispatch(_didDetectAuth());

    if (handler) {
      dispatch(handler());
    }
  };
};

var detectAuth = exports.detectAuth = function detectAuth(_ref2) {
  var _ref2$AuthHandler = _ref2.AuthHandler,
      AuthHandler = _ref2$AuthHandler === undefined ? _Auth3.default : _ref2$AuthHandler,
      _ref2$getPortalId = _ref2.getPortalId,
      getPortalId = _ref2$getPortalId === undefined ? function () {
    return _QueryParamsContainer2.default.get('portalId');
  } : _ref2$getPortalId,
      handleAuthed = _ref2.handleAuthed,
      handleNotAuthed = _ref2.handleNotAuthed;
  return function (dispatch) {
    (0, _AnalyticsActions.trackEvent)('view', { screen: 'detect-auth' });
    if (!_isFunnel2.default.partnerClient()) {
      (0, _AnalyticsActions.trackEvent)('view', { screen: 'signup' }); // TODO ??
    }

    var options = {};
    var portalId = getPortalId && getPortalId();
    if (portalId) {
      options.portalId = portalId;
    }

    AuthHandler.init(options).then(function () {
      return dispatch(didDetectAuth(handleAuthed, AuthHandler));
    }).catch(function (error) {
      if (error) {
        LOG.error('Error while detecting Auth', { extra: { error: error } });
      }
      dispatch(didDetectUnauthed(handleNotAuthed));
    }).done();
  };
};